console.log('user.mjs v.0.2.2');

import { modals } from './modal.mjs';
import { loader } from './loader.mjs';
import { validation } from './validation.js';
import { csrf } from './csrfToken.mjs';
import { unique } from './unique.mjs';

export const user = (() => {
  let USER = {};
  let STEP = 1;
  let currentModal;
  const loginSignupPage = document.querySelector('.login-signup-page-content');
  const loginSignupHeading = document.querySelector('.login-signup-page-heading');

  document.addEventListener("DOMContentLoaded", function(){
    if(loginSignupPage) {
      init();
      user.emailCheck.openPage();
    }
  });

  const init = () => {
    // check if there is a signup / login button
    const signupLoginTrigger = document.querySelector('a[data-trigger="modal-login-or-register"]');

    if (!signupLoginTrigger) {
      return;
    }

    signupLoginTrigger.addEventListener('click', function(event) {
      event.preventDefault();
      user.emailCheck.open();
    });

    function statusChangeCallback(response) {  // Called with the results from FB.getLoginStatus().
      console.log('statusChangeCallback');
      console.log(response);                   // The current login status of the person.

      if (response.status === 'connected') {   // Logged into your webpage and Facebook.
        const url = '/account/auth/facebook';
        const body = {
          accessToken: response.authResponse.accessToken,
          userId: response.authResponse.userID
        }

        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        };

        fetch(url, params)
        .then(response => {
          console.log(response);
        })
        .then(data => {

        })
        .catch(error => {

        });


      } else {                                 
        console.log('something went wrong with logging in');
      }
    }
    
    window.fbAsyncInit = function() {
      FB.init({
        appId      : facebookAppId,
        cookie     : true, 
        xfbml      : true,  // parse social plugins on this page
        version    : 'v16.0' // Specify the Graph API version to use
      });

      // Now that we've initialized the JavaScript SDK, we call 
      // FB.getLoginStatus().  This function gets the state of the
      // person visiting this page and can return one of three states to
      // the callback you provide.  They can be:
      //
      // 1. Logged into your app ('connected')
      // 2. Logged into Facebook, but not your app ('not_authorized')
      // 3. Not logged into Facebook and can't tell if they are logged into
      //    your app or not.
      //
      // These three cases are handled in the callback function.

      FB.getLoginStatus(function(response) {
        statusChangeCallback(response);
      });
    };
    // Load the SDK asynchronously
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  init();

  return {
    emailCheck: {
      open: () => {
        modals.create(translations.userMenu.loginSignupTitle, user.render.emailCheckBody(), '', { 'id': unique.id('modal-'), 'headerClass': 'title-large'} );

        currentModal = modals.get.modal();
        const focusField = currentModal.querySelector('.user-flow-wrapper #email-check-email');

        currentModal.addEventListener('submit', (e) => {
          user.events.emailCheckSubmit(e, currentModal);
        });
        currentModal.addEventListener('click', user.events.facebookLogin);

        user.render.socialGoogle();
        focusField.focus();
      },
      openPage: () => {
        loginSignupHeading.innerHTML = '<h2>Log in / Sign up</h2>'
        loginSignupPage.innerHTML = user.render.emailCheckBody();
        const focusField = document.querySelector('.user-flow-wrapper #email-check-email');
  
        document.addEventListener('submit', (e) => {
          user.events.emailCheckSubmit(e, document);
        });
        document.addEventListener('click', user.events.facebookLogin);
  
        user.render.socialGoogle();
        focusField.focus();
      }
    },
    login: {
      open: () => {
        modals.update(translations.userMenu.login, user.render.loginBody(), '', { 'headerClass': 'title-large', 'backButton': true });
        const passwordField = currentModal.querySelector('#login-password-field');
        currentModal.addEventListener('submit', function(e){
          user.events.loginFormSubmit(e, currentModal);
        });
        currentModal.addEventListener('click', user.events.passwordVisibility);
        currentModal.addEventListener('click', function(e){
          user.events.forgotPasswordLink(e, currentModal);
        });
        passwordField.focus();
      },
      openPage: () => {
        loginSignupHeading.innerHTML = '<h2>Log in</h2>'
        loginSignupPage.innerHTML = user.render.loginBody();
        const passwordField = document.querySelector('#login-password-field');
        document.addEventListener('submit', function(e){
          user.events.loginFormSubmit(e, document);
        });
        document.addEventListener('click', user.events.passwordVisibility);
        document.addEventListener('click',function(e){
          user.events.forgotPasswordLink(e, document);
        });
        passwordField.focus();
      },
      submit: (loginForm, loginButton) => {
        const passwordField = document.querySelector('#login-password-field');
        USER['password'] = passwordField.value;

        const csrfToken = document.querySelector('#csrfToken').value;

        var request = {
          "email": USER.email,
          "password": USER.password,
          "pageType": document.querySelector('#login-page-type').value
        };
        
        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        }

        gae('customer','login_email_submit');

		    fetch("/account/auth/login", params)
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          if (response.status == "ok") {
            gae('customer','login_email_submit_ok');

            if(window.location.href.indexOf('/login') > -1) {
              const redirectUrl = document.referrer;
              window.location.href = redirectUrl;
            }
            else {
              window.location.reload();
            }
          }
          if (response.status == "error") {
            loginForm === document ? user.render.errorPage(response.error) : user.render.error(response.error, loginForm);
            loader.status.doneLoading(loginButton);
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      }
    },
    register: {
      open: () => {
        let footer = `
          <p class="centered">${ translations.userMenu.proceedingConfirms }</p>
        `;
        modals.update(translations.userMenu.signUp, user.render.signupBody(), footer, { 'headerClass': 'title-large', 'backButton': true });

        const passwordField = currentModal.querySelector('#signup-password-field');
        const signupButton = currentModal.querySelector('button[data-trigger="sign-up-bttn"]');
        const references = user.helper.passwordStrength(passwordField);

        currentModal.addEventListener('click', user.events.passwordVisibility);
        currentModal.addEventListener('submit', function(e){
          user.events.registerFormSubmit(e, currentModal);
        });

        passwordField.addEventListener('keyup', function(event) {
          if (event.target.value.length > 2) {
            user.helper.passwordStrengthCheck(event.target.value, references);
            validation.isPasswordValid(event.target, '.password-validation');
          }
        });

        passwordField.addEventListener('blur', function(event) {
          user.helper.passwordStrengthCheck(event.target.value, references);
          validation.isPasswordValid(event.target, '.password-validation');
        });
      },
      openPage: () => {
        let footer = `
          <p class="centered">${ translations.userMenu.proceedingConfirms }</p>
        `;
        loginSignupHeading.innerHTML = '<h2>Sign up</h2>'
        loginSignupPage.innerHTML = `${user.render.signupBody()} <footer>${footer}</footer>`;
        const passwordField = document.querySelector('#signup-password-field');
        const references = user.helper.passwordStrength(passwordField);

        document.addEventListener('click', user.events.passwordVisibility);
        document.addEventListener('submit', function(e){
          user.events.registerFormSubmit(e, document);
        });

        passwordField.addEventListener('keyup', function(event) {
          if (event.target.value.length > 2) {
            user.helper.passwordStrengthCheck(event.target.value, references);
            validation.isPasswordValid(event.target, '.password-validation');
          }
        });

        passwordField.addEventListener('blur', function(event) {
          user.helper.passwordStrengthCheck(event.target.value, references);
          validation.isPasswordValid(event.target, '.password-validation');
        });
      },
      submit: (elm, signupButton) => {
        user.helper.errors.remove();

        const csrfToken = document.querySelector('#csrfToken').value; 

        const request = {
          "first_name": document.querySelector('#signup-first-name').value,
          "last_name": document.querySelector('#signup-last-name').value,
          "email": document.querySelector('#signup-email').value,
          "password": document.querySelector('#signup-password-field').value,
          "newsletter": document.querySelector("#signup-newsletter").checked,
          //"pageType": document.querySelector('#signup-page-type').value
        };

        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        }

      fetch("/account/auth/signup", params)
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          setTimeout(function() {

            if (response.status == "ok") {
              marketing.trackSoftGoals(marketing.SoftGoals.AccountRegistration, 'form');
              gae('customer','signup_email_submit_ok');
              elm === document ? user.register.completeRegistrationPage(): user.register.completeRegistration();
            }
            else {
              let error = response.error; 
              if (error == 'Account already exists') {
                loader.status.doneLoading(signupButton);
                const container = document.querySelector('.account-register');
                elm === document ? user.render.errorPage(error) : user.render.error(error, container);
              }
              else {
                /*
                errorBlock.classList.add('active');
                submitButton.disabled = false;
                errorBlock.innerHTML = error;
                */
              }
              gae('customer','signup_email_submit_error');
            }
          }, 1000);
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      },
      completeRegistration: () => {
        modals.update('', user.render.completeRegistrationBody(), '', { 'bodyClass': 'step-confirm-email' });
        currentModal.querySelector('.resend').addEventListener('click', function(event) {
          user.events.resend(event);
        });
      },
      completeRegistrationPage: () => {
        const redirectUrl = document.referrer;
        window.location.href = redirectUrl;
      }
    },
    checkEmail: (elm, continueButton) => {
      const emailField = document.querySelector('#email-check-email');
      if (validation.isValidEmail(emailField.value) == false) {
        user.render.error(translations.userMenu.invalidEmail, emailField);
        loader.status.doneLoading(continueButton);
        return;
      }
      
      const url = `/email-check?email=${emailField.value}`;
			const params = {
				credentials: 'same-origin',
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}

      USER['email'] = emailField.value;

      fetch(url, params )
      .then(response => {
        if (response.status == 200) {
          return response.json(); 
        }
      })
      .then(data => {
        loader.status.doneLoading(continueButton);
        if (data.userExists == true) {
          elm === document ? user.login.openPage() : user.login.open();
        }
        if (data.userExists == false) {
          elm === document ? user.register.openPage() : user.register.open();
        }
      })
      .catch(error => {
        // TODO proper error handling
        console.log(error);
      });
    },
    forgotPassword: {
      open: () => {
        modals.update(translations.userMenu.forgotPassword, user.render.forgotPasswordBody(), '', { 'headerClass': 'title-large', 'backButton': true });
        
        const formForgotPassword = currentModal.querySelector('form#form-forgot-password');
        const submitButton = currentModal.querySelector('button[data-trigger="reset-link"]');

        formForgotPassword.addEventListener('submit', function(event) {
          event.preventDefault();
          loader.status.isLoading(submitButton);
          user.forgotPassword.submit(event, submitButton, currentModal);
        });
      },
      openPage: () => {
        loginSignupHeading.innerHTML = '<h2>Forgot your password ?</h2>';
        loginSignupPage.innerHTML = user.render.forgotPasswordBody();
        const formForgotPassword = document.querySelector('form#form-forgot-password');
        const submitButton = document.querySelector('button[data-trigger="reset-link"]');

        formForgotPassword.addEventListener('submit', function(event) {
          event.preventDefault();
          loader.status.isLoading(submitButton);
          user.forgotPassword.submit(event, submitButton, document);
        });
      },
      submit: (event, submitButton, elm) => {

        const csrfToken = document.querySelector('#csrfToken').value; 

        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify({"email": USER['email']}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        }

        gae('customer','forgot_password_submit');

        fetch("/account/auth/forgot-password", params)
          .then(function(response) {
            return response.json();
          })
          .then(function(response) {

            if (response.status == "error") {
              setTimeout(function() {
                submitButton.classList.remove('is-loading');
                errorBlock.classList.add('active');
                errorBlock.innerHTML = response.error;
              }, 1000);
            }

            if (response.status == "redirect") {
              form.reset();
              window.location.replace(response.redirectUrl);
            }

            if (response.status == "ok") {
              elm === document ? user.forgotPassword.sentPage() :user.forgotPassword.sent();
            }
          })
          .catch(function(error) {
            console.error('Error:', error);
          });
      },
      sent: () => {
        modals.update(translations.userMenu.resetLinkSent, user.render.sentBody(), '', {});

        const resendButton = document.querySelector('.user-flow-wrapper a.resend');

        resendButton.addEventListener('click', function(event) {
          user.forgotPassword.resend(event);
        });
      },
      sentPage: () => {
        loginSignupHeading.innerHTML = '<h2>A reset link has been sent</h2>'
        loginSignupPage.innerHTML = user.render.sentBody();

        const resendButton = document.querySelector('.user-flow-wrapper a.resend');

        resendButton.addEventListener('click', function(event) {
          user.forgotPassword.resend(event);
        });
      },
      resend: (event) => {
        const link = event.target;
        const csrfToken = document.querySelector('#csrfToken').value; 

        const request = {
          'email': USER['email']
        }

        link.innerHTML = `<span>sending ...</span>`;

        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        }

        fetch("/account/auth/forgot-password", params)
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          if (response.status == "ok") {
            link.outerHTML = `<span class="message-sent">✓ email sent</span>`;
          }
          else {
            link.outerHTML = `<span class="message-error"> ${response.error} </span>`;
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      }
    },
    helper: {
      nextStep: (STEP) => {
        // get current step element
        const current = docuement.querySelector(`.user-flow-wrapper[data-step="${STEP}"]`);
        current.classList.add('slide-out');

        setTimeout(function() {
          current.classList.remove('slide-out');
          current.classList.add('hidden');
        }, 200);
        // transition out
      },
      previousStep: (STEP) => {
        // get current step element
        const current = docuement.querySelector(`.user-flow-wrapper[data-step="${STEP}"]`);
        current.classList.remove('hidden');
        current.classList.add('slide-in');

        setTimeout(function() {
          current.classList.remove('slide-in');
        }, 200);
      },
      passwordStrength: (element) => {
        const references = {};

        references['minimalPasswordLength'] = 8;
        references['checkLengthElement'] = document.querySelector('.password-check .check-length');
        references['checkNumberElement'] = document.querySelector('.password-check .check-number');
        references['checkUppercaseElement'] = document.querySelector('.password-check .check-uppercase');
        references['checkLowercaseElement'] = document.querySelector('.password-check .check-lowercase');
        return references;
      },
      passwordStrengthCheck: (value, references) => {
        validation.setValidation(references.checkLengthElement, validation.isMinimalLength(value, references['minimalPasswordLength']));
        validation.setValidation(references.checkNumberElement, validation.containsNumbers(value));
        validation.setValidation(references.checkUppercaseElement, validation.containsUppercaseCharacters(value));
        validation.setValidation(references.checkLowercaseElement, validation.containsLowercaseCharacters(value));
      },
      passwordVisibilityToggle: (event) => {
        const formElement = validation.findAncestor(event.target, '.has-password-visibility-switcher');
        const input = formElement.querySelector('.form-control');

        if (input.type == "password") {
          input.type = "text";
          event.target.classList.add('is-visible');
        }
        else {
          input.type = "password";
          event.target.classList.remove('is-visible');
        }
      },
      errors: {
        remove: () => {
          const errors = document.querySelectorAll('.alert.alert--error');
          if (errors.length > 0) {
            errors.forEach(error => {
              error.remove();
            });
          }
        }
      }
    },

    /*
     * All the event handlers, named, so we can remove them if needed.
     */
    events: {
      passwordVisibility: (event) => {
        if (event.target.classList.contains('toggle-password-visibility')) {
          user.helper.passwordVisibilityToggle(event);
        }
      },
      forgotPasswordLink: (event, elm) => {
        if (event.target.classList.contains('forgot-password-link')) {
          elm === document ? user.forgotPassword.openPage() :user.forgotPassword.open(); 
        }
      },
      emailCheckSubmit: (event, elm) => {
        if (event.target.id == "form-email-check") {
          event.preventDefault();
          const continueButton = elm.querySelector('button[data-trigger="email-check-continue"]');

          loader.status.isLoading(continueButton);
          user.checkEmail(elm, continueButton);
          STEP++;
        }
      },
      loginFormSubmit: (event, elm) => {
        if (event.target.id == "form-account-login") {
          event.preventDefault();

          const loginButton = document.querySelector('button[data-trigger="log-in"]');
          loader.status.isLoading(loginButton);
          user.login.submit(elm, loginButton);
        }
      },
      registerFormSubmit: (event, elm,) => {
        if (event.target.id == "form-account-register") {
          event.preventDefault();

          const registerButton = document.querySelector('button[data-trigger="sign-up-bttn"]');
          loader.status.isLoading(registerButton);
          user.register.submit(elm, registerButton);
        }
      },
      facebookLogin: (event) => {
        if (event.target.classList.contains('fb-login-loading-button')) {
          FB.login(function(response){
            if (response.status === 'connected') {
              console.log("yeaah connected!");
            } else {
              // The person is not logged into your webpage or we are unable to tell. 
            }
          }, {scope: 'public_profile,email'});
        }
      },
      resend: (event) => {
        const link = event.target;
        const csrfToken = document.querySelector('#csrfToken').value; 

        const request = {
          'email': USER['email']
        }

        link.innerHTML = `<span>sending ...</span>`;

        const params = {
          credentials: 'same-origin',
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        }

        fetch("/account/auth/resend-verification", params)
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          if (response.status == "ok") {
            link.outerHTML = `<span class="message-sent">✓ email sent</span>`;
          }
          else {
            link.outerHTML = `<span class="message-error"> ${response.error} </span>`;
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      }
    },

    /*
     * Render methods
     */
    render: {
      error: (message, container) => {
        const body = `
          <p class="alert alert--error">${message}</p> 
        `;
        
        container.insertAdjacentHTML('afterbegin', body);
      },
      errorPage: (message) => {
        const body = `
          <p class="alert alert--error">${message}</p> 
        `;
        document.querySelector(".login-signup-page-error").innerHTML = body;
      },
      fields: {
        text: (id, name, label, placeholder = '', required = false) => {
         let body = `
          <div class="form-group simple-validation">
            <label for="${id}">${label}</label>
            <input type="text" id="${id}" name="${name}" class="form-control text" ${required ? 'required="required"' : ''} placeholder="${placeholder}" value="" />
          </div>
         `;

          return body;
        },
        email: (type, value = '') => {
          let body = `
          <div class="form-group email-validation">
            <label for="email">email</label>
            <input type="email" id="${type}-email" name="email" class="form-control text" placeholder="e.g john@smith.com" value="${value}" //>
          </div>
          `;

          return body;
        },
        password: (hasStrengthCheck = false, id = 'field') => {
          let body = `
            <div class="form-group ${ hasStrengthCheck == true ? "password-validation" : "" } has-password-visibility-switcher">
              <label for="${id}-password" class="label">${ translations.userMenu.password }</label>
              <div class="relative-wrap">
                <input type="password" placeholder="${ translations.userMenu.enterYourPassword }" class="form-control password" id="${id}-password-field" required name="password">
                <span class="toggle-password-visibility toggle-password-visibility--grey">
                  <svg fill="none" xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="eye-open"><path stroke-width="2" d="M1.373 13.183a2.064 2.064 0 010-2.366C2.946 8.59 6.819 4 12 4c5.181 0 9.054 4.59 10.627 6.817a2.064 2.064 0 010 2.366C21.054 15.41 17.181 20 12 20c-5.181 0-9.054-4.59-10.627-6.817z" stroke-linecap="round" stroke="#7C8086" stroke-linejoin="round" stroke-miterlimit="10"></path><path stroke-width="2" d="M12 16a4 4 0 100-8 4 4 0 000 8z" stroke-linecap="round" stroke="#7C8086" stroke-linejoin="round" stroke-miterlimit="10"></path></svg>
                  <svg fill="none" xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="eye-closed"><path stroke-width="2" d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" stroke-linecap="round" stroke="#7C8086" stroke-linejoin="round" stroke-miterlimit="10"></path><path stroke-width="2" d="M12 15a3 3 0 100-6 3 3 0 000 6zM3 21L21 3" stroke-linecap="round" stroke="#7C8086" stroke-linejoin="round" stroke-miterlimit="10"></path></svg>
                </span>
              </div>

              ${ hasStrengthCheck == true ? user.render.fields.passwordStrength() : '' }
            </div>
          `;

          return body;
        },
        passwordStrength: () => {
          let body = `
            <p class="password-check">
              <span class="check-length">
              <svg class="icon icon--svg icon-check" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 2.5L3 5L7.5 0.5" stroke="#078372" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              ${translations.userMenu.atLeast8Characters}
              </span>

              <span class="check-number">
                <svg class="icon icon--svg icon-check" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 2.5L3 5L7.5 0.5" stroke="#078372" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ${ translations.userMenu.oneNumberInPassword }
              </span>

              <span class="check-uppercase">
                <svg class="icon icon--svg icon-check" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 2.5L3 5L7.5 0.5" stroke="#078372" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ${ translations.userMenu.oneUppercaseInPassword }
              </span>

              <span class="check-lowercase">
                <svg class="icon icon--svg icon-check" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 2.5L3 5L7.5 0.5" stroke="#078372" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ${ translations.userMenu.oneLowercaseInPassword }
              </span>
            </p>
          `;

          return body;
        },
        forgotPassword: () => {
          let body = `
            <p class="forgotten-password">
              <a
                href="#"
                tabindex="0"
                class="forgot-password-link"
                onclick="gae('customer','login_forgot_password_link');"
              >
              ${ translations.userMenu.forgotPassword }
              </a>
            </p>
          `;

          return body;
        },
        newsletter: () => {
          let body = `
            <div class="form-group form-group--newsletter">
              <label class="b-contain inline">
                <span> ${translations.userMenu.receiveNewsletter }</span>
                <input type="checkbox" id="signup-newsletter" name="newsletter">
                <div class="b-input"></div>
              </label>
            </div>
          `;

          return body;
        }
      },
      submitButton: (trigger, displayText) => {
        const button = `
				<button class="bttn bttn-submit has-loader has-loader--light" type="submit" data-trigger="${trigger}">
					<span class="default-value">${ displayText }</span>
					<span class="loader">
            ${loader.render.spinner()}
					</span>
				</button>`;

        return button;
      },
      backButton: () => {
        const button = `
          <button class="back"> 
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 19L5 12L12 5" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        `;

        return button;
      },
      termsAndConditionsMessage: () => {
        const body = `
         <p>${ translations.userMenu.proceedingConfirms }</p>
        `;

        return body;
      },
      separator: () => {
        const element = `
        <div class="section-seperator">
          <span>${translations.userMenu.or }</span>
        </div>`;

        return element;
      },
      socialGoogle: () => {
        google.accounts.id.initialize({
          client_id: "478732585615-s8dg6osif5kqmls43gj8ape4o698i9j4.apps.googleusercontent.com",
          context: "signin",
          ux_mode: "popup",
          login_uri: "/account/auth/google",
          auto_prompt: false
        });

        google.accounts.id.renderButton(
          document.querySelector(".google-login"), 
          {
            type: "standard",
            theme: "outline", 
            size: "large",
            // see: https://developers.google.com/identity/gsi/web/guides/display-button#button_language
          }
        );

        google.accounts.id.prompt();
      },
      socialFacebook: () => {
        const element = `
          <div class="button-container">
            <div 
              class="fb-login-loading-button fb-login-button-new"
              onclick="gae('customer','login_with_facebook');">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.8987 0H4.10133C1.83623 0 0 1.83623 0 4.10133V19.8987C0 22.1638 1.83623 24 4.10133 24H19.8987C22.1638 24 24 22.1638 24 19.8987V4.10133C24 1.83623 22.1638 0 19.8987 0Z" fill="#0076EC"/>
                  <path d="M16.4684 24V14.7852H19.5611L20.025 11.1934H16.4684V8.90027C16.4684 7.86 16.7566 7.15185 18.2484 7.15185H20.1497V3.94142C19.8211 3.89749 18.693 3.80084 17.3786 3.80084C14.6374 3.80084 12.7607 5.47371 12.7607 8.54707V11.1952H9.65918V14.7869H12.7607V24.0017H16.4684V24Z" fill="white"/>
                </svg>
                <span class="centered">Continue with Facebook</span>
            </div>
          </div>`;

        return element;
      },
      emailCheckBody: () => {
        const body = `
          <div class="user-flow-wrapper account-signup-and-login" data-step="1">
            <form id="form-email-check">
              ${user.render.fields.email('email-check')}
              ${user.render.submitButton('email-check-continue', translations.userMenu.continue)}

              <div class="social-login">
                ${user.render.separator()}
                <div class="google-login"></div>
                ${user.render.socialFacebook()}
              </div>
            </form>
          </div>
        `;
        return body;
      },
      loginBody: () => {
        const body = `
          <div class="user-flow-wrapper account-login" data-step="2">
            <form id="form-account-login">
              ${user.render.fields.password(false, 'login')}
              ${user.render.fields.forgotPassword()}
              ${user.render.submitButton('log-in', translations.userMenu.login)}
            </form>
          </div>
        `;
        return body;
      },
      forgotPasswordBody: () => {
        const body = `
          <div class="user-flow-wrapper" data-step="6">
            <form id="form-forgot-password">
              <p class="centered">${ translations.userMenu.forgotPasswordText }</p>

              ${user.render.fields.email('forgot-password', USER['email'])}
              ${user.render.submitButton('reset-link', translations.userMenu.sendResetLink )}
            </form>
          </div>
        `;
        return body;
      },
      sentBody: () => {
        const body = `
          <div class="user-flow-wrapper forgot-password-sent" data-step="7">
            <svg class="centered" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.9535 10.5996C26.7227 10.5996 25.615 11.215 24.9996 12.1996C24.3842 11.215 23.2765 10.5996 22.0458 10.5996C20.0765 10.5996 18.5996 12.1996 18.5996 14.1688C18.5996 17.615 24.9996 22.9073 24.9996 22.9073C24.9996 22.9073 31.3996 17.615 31.3996 14.1688C31.3996 12.1996 29.9227 10.5996 27.9535 10.5996Z" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 17L1 21.64V49H49V21.64L41 17" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 26.12V1H41V25.96" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1 21.6387L49 48.9987" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M48.9994 21.6387L24.3594 34.9187" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <p class="sent-to-message centered">${ translations.userMenu.passwordResetEmail }</p>
            <p class="centered">${ translations.userMenu.noEmail } <a class="resend">${ translations.userMenu.resend }</a>
          </div>
        `;
        return body;
      },
      signupBody: () => {
        const body = `
          <div class="user-flow-wrapper account-register" data-step="2">
            <form id="form-account-register">
              ${user.render.fields.email('signup', USER['email'])}
              ${user.render.fields.text('signup-first-name', 'first-name', translations.userMenu.firstName, translations.userMenu.enterYourFirstName, true)}
              ${user.render.fields.text('signup-last-name', 'last-name', translations.userMenu.lastName, translations.userMenu.enterYourLastName, true)}

              ${user.render.fields.password(true, 'signup')}
              ${user.render.fields.newsletter()}
              ${user.render.submitButton('sign-up-bttn', translations.userMenu.signUp)}
            </form>
          </div>
        `;
        return body;
      },
      completeRegistrationBody: () => {
        const body = `
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.9535 10.5994C26.7227 10.5994 25.615 11.2148 24.9996 12.1994C24.3842 11.2148 23.2765 10.5994 22.0458 10.5994C20.0765 10.5994 18.5996 12.1994 18.5996 14.1686C18.5996 17.6148 24.9996 22.9071 24.9996 22.9071C24.9996 22.9071 31.3996 17.6148 31.3996 14.1686C31.3996 12.1994 29.9227 10.5994 27.9535 10.5994Z" stroke="#078372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 16.9998L1 21.6398V48.9998H49V21.6398L41 16.9998" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 26.12V1H41V25.96" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1 21.6395L49 48.9995" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M48.9994 21.6395L24.3594 34.9195" stroke="#202244" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h2>
            ${translations.userMenu.welcomeTo}
            <span class="logo">
              <svg width="127" height="29" viewBox="0 0 127 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M97.7714 11.9002C97.4649 9.74561 96.5821 8.22693 95.1249 7.31715C93.935 6.61092 92.564 6.25738 91.1759 6.29876C90.6114 6.30089 90.0478 6.3417 89.489 6.42091C87.2137 6.73552 85.5205 7.60688 84.3891 9.03226C83.4901 10.1409 83.0055 11.521 83.0167 12.9405C83.0174 13.2931 83.043 13.6452 83.0932 13.9942L83.7015 18.2792C83.9953 20.3459 84.8184 21.8824 86.1715 22.9088C87.3426 23.724 88.7568 24.1285 90.1883 24.0578C90.7971 24.0548 91.4049 24.0102 92.0075 23.9243C93.8111 23.7587 95.5095 23.0126 96.8406 21.8009C97.2969 21.377 97.6599 20.865 97.9069 20.2969C98.1539 19.7287 98.2797 19.1165 98.2766 18.4983C98.276 18.2417 98.2574 17.9854 98.2208 17.7313C98.2178 17.6892 98.2063 17.648 98.1871 17.6102C98.1679 17.5724 98.1414 17.5387 98.1089 17.511C98.0289 17.4569 97.9326 17.4311 97.8358 17.4377C97.7845 17.4381 97.7333 17.442 97.6826 17.4494L94.2125 17.9282C94.0805 17.9481 93.9565 18.0035 93.8542 18.0882C93.7518 18.1729 93.6751 18.2838 93.6323 18.4086C93.433 18.8339 93.1204 19.198 92.7279 19.462C92.3354 19.726 91.8777 19.8801 91.4034 19.9079C91.195 19.9375 90.9848 19.9527 90.7743 19.9536C90.2487 19.9714 89.7301 19.8312 89.2872 19.5516C89.0308 19.3887 88.8136 19.1724 88.6511 18.9179C88.4886 18.6633 88.3846 18.3768 88.3465 18.0783L88.3089 17.8125C88.2971 17.7324 88.2911 17.6517 88.2907 17.5708C88.2792 17.357 88.3489 17.1467 88.4861 16.9807C88.6383 16.8253 88.8425 16.7296 89.0608 16.7112L96.5043 15.6838C96.7426 15.6583 96.9725 15.5828 97.1788 15.4625C97.3851 15.3422 97.5629 15.1798 97.7003 14.9862C97.9236 14.6752 98.0412 14.3025 98.0361 13.9215C98.0359 13.812 98.028 13.7026 98.0124 13.5942L97.7714 11.9002ZM92.9224 13.3027C92.7642 13.464 92.552 13.5633 92.3253 13.5825L88.6874 14.0846C88.6278 14.0931 88.5677 14.0974 88.5075 14.0976C88.4059 14.1022 88.3045 14.0859 88.2096 14.0499C88.1147 14.0139 88.0284 13.9589 87.9561 13.8884C87.8086 13.7208 87.719 13.5114 87.7002 13.2903C87.6844 13.18 87.6765 13.0688 87.6765 12.9574C87.6829 12.4011 87.8876 11.8648 88.2548 11.4424C88.7104 10.8826 89.3709 10.5218 90.0939 10.4381C90.2701 10.4133 90.4479 10.4006 90.626 10.4001C91.1495 10.39 91.6645 10.5313 92.1076 10.8064C92.3879 10.9876 92.6232 11.2287 92.7963 11.5117C92.9693 11.7948 93.0755 12.1126 93.1071 12.4417C93.1192 12.5241 93.1254 12.6073 93.1258 12.6905C93.1377 12.9124 93.0651 13.1307 92.9224 13.3027ZM63.881 11.5769C63.8794 9.67718 63.2383 8.27195 61.9556 7.32882C60.6719 6.38564 58.7305 5.90631 56.1281 5.90666C54.8758 5.909 53.6298 6.08291 52.426 6.42342C51.387 6.66403 50.4306 7.17024 49.6529 7.89113L49.6518 7.89224C49.5882 7.97447 49.5591 8.07769 49.5705 8.18051C49.5746 8.25256 49.5956 8.32268 49.6318 8.3854L51.0349 11.1529C51.0623 11.2027 51.1025 11.2444 51.1514 11.274C51.2004 11.3035 51.2564 11.3198 51.3138 11.3212C51.4233 11.3189 51.5301 11.2868 51.6224 11.2285C52.1844 10.8528 52.8104 10.5798 53.4705 10.4227C54.1868 10.2223 54.927 10.1167 55.6715 10.1089C56.5113 10.0798 57.3505 10.1802 58.1588 10.4067C58.4368 10.4892 58.6815 10.656 58.858 10.8834C59.021 11.1177 59.1034 11.3973 59.0933 11.6813C59.0881 11.8851 59.0261 12.0836 58.9139 12.255C58.8018 12.4263 58.6439 12.5639 58.4577 12.6525L58.455 12.6542C58.1243 12.8225 57.7737 12.9497 57.4112 13.0328C56.8902 13.1764 56.1932 13.3391 55.3202 13.5209C54.5858 13.6731 53.9775 13.7992 53.4953 13.8993C52.9224 14.0329 52.3675 14.2322 51.8417 14.4932C51.2836 14.7452 50.7744 15.0913 50.3371 15.516C49.9146 15.9713 49.5865 16.5036 49.3712 17.0831C49.0922 17.8154 48.9569 18.5934 48.9724 19.3756C48.9413 20.3762 49.2779 21.3542 49.9202 22.1294C50.499 22.8413 51.2639 23.3838 52.1323 23.6986C53.0098 24.0007 53.9337 24.1514 54.8631 24.144C56.8435 24.144 58.383 23.7411 59.4871 22.947L59.49 22.945C59.6456 22.8235 59.8322 22.7467 60.0293 22.7232C60.0939 22.7192 60.1586 22.7287 60.2191 22.7513C60.2796 22.7738 60.3346 22.8087 60.3805 22.8537C60.4658 22.9571 60.5083 23.0886 60.4993 23.2216C60.4946 23.2721 60.5014 23.323 60.5192 23.3707C60.537 23.4183 60.5654 23.4613 60.6022 23.4967C60.7009 23.5664 60.8215 23.5992 60.9424 23.5891H63.4024C63.4677 23.5999 63.5346 23.5951 63.5976 23.5752C63.6607 23.5553 63.718 23.5209 63.7648 23.4747C63.8116 23.4286 63.8465 23.3721 63.8667 23.3099C63.8869 23.2478 63.8918 23.1817 63.8809 23.1174L63.881 11.5769ZM59.0931 17.4071C59.0936 18.5385 58.7911 19.351 58.1642 19.8168C57.547 20.272 56.7937 20.5116 56.0231 20.4979C55.4923 20.5063 54.9737 20.3402 54.5492 20.0257C54.3365 19.8683 54.1662 19.6619 54.0531 19.4246C53.94 19.1873 53.8875 18.9262 53.9004 18.6643C53.8914 18.3454 53.9539 18.0286 54.0834 17.7363C54.206 17.4771 54.4076 17.2621 54.6601 17.1213C54.8699 16.9971 55.0923 16.8951 55.3238 16.8171C55.5116 16.7579 55.7688 16.6828 56.0953 16.5882L56.0995 16.5871L58.4538 16.0324L58.4733 16.0301C58.5591 16.0246 58.6451 16.0375 58.7254 16.068C58.8056 16.0985 58.8781 16.1459 58.938 16.2068C59.0503 16.3493 59.1055 16.5275 59.0931 16.7075V17.4071ZM113.918 17.3331C113.922 17.2885 113.915 17.2437 113.898 17.2024C113.88 17.1612 113.853 17.1248 113.818 17.0965C113.713 17.0324 113.591 17.003 113.468 17.0127H110.227C110.104 17.0143 109.985 17.049 109.881 17.1132C109.777 17.1774 109.693 17.2684 109.638 17.3765C109.399 17.7418 109.065 18.0365 108.67 18.2293C108.275 18.4221 107.835 18.5057 107.396 18.4713C106.71 18.5147 106.033 18.3021 105.499 17.8757C105.285 17.6935 105.113 17.4672 104.997 17.2127C104.881 16.9581 104.823 16.6816 104.827 16.4024V16.1542C104.809 15.9088 104.884 15.6656 105.036 15.471C105.117 15.3889 105.215 15.3252 105.324 15.2843C105.433 15.2434 105.549 15.2262 105.665 15.2341H112.618C112.839 15.2408 113.058 15.201 113.262 15.1171C113.466 15.0333 113.649 14.9075 113.8 14.7481C114.113 14.4142 114.28 13.9714 114.265 13.5165V11.9341C114.264 9.92254 113.653 8.42184 112.438 7.40549C111.219 6.38646 109.543 5.87338 107.396 5.87315C105.271 5.87373 103.608 6.45746 102.388 7.61903C101.79 8.18181 101.317 8.86222 101.002 9.61627C100.687 10.3703 100.535 11.1813 100.558 11.9966V15.9993C100.512 16.8285 100.635 17.6583 100.92 18.4398C101.205 19.2212 101.646 19.9382 102.217 20.5485C103.316 21.654 105.048 22.2147 107.427 22.2149C109.1 22.2913 110.751 21.8229 112.127 20.8819C112.699 20.4812 113.161 19.9476 113.473 19.3286C113.786 18.7096 113.939 18.0242 113.918 17.3331ZM105.608 10.3068C106.099 9.85055 106.752 9.60309 107.427 9.6178C108.081 9.59105 108.722 9.80227 109.228 10.2113C109.462 10.4133 109.647 10.6647 109.769 10.9467C109.891 11.2288 109.948 11.5343 109.934 11.8407C109.952 12.0948 109.874 12.3466 109.716 12.5477C109.631 12.6327 109.529 12.6986 109.417 12.741C109.304 12.7833 109.183 12.8011 109.063 12.793H105.665C105.554 12.8005 105.443 12.7847 105.338 12.7466C105.234 12.7085 105.139 12.649 105.06 12.5721C104.913 12.3923 104.841 12.1644 104.857 11.9342C104.857 11.6258 104.924 11.3211 105.054 11.0404C105.183 10.7597 105.372 10.5096 105.608 10.3068ZM126.238 9.40397L124.833 9.29169C124.674 9.27896 124.52 9.27257 124.371 9.27253C123.985 9.24861 123.598 9.3005 123.233 9.4252C122.867 9.5499 122.531 9.74493 122.242 9.99897C121.695 10.5911 121.386 11.3598 121.373 12.1606L120.615 21.3895C120.615 21.5085 120.57 21.6233 120.491 21.7128C120.449 21.749 120.401 21.7766 120.348 21.794C120.296 21.8114 120.24 21.8182 120.185 21.814L120.113 21.811L116.377 21.5127C116.256 21.512 116.14 21.4685 116.049 21.39C116.013 21.3491 115.985 21.3013 115.967 21.2495C115.949 21.1977 115.943 21.1429 115.947 21.0884L115.95 21.0172L117.246 5.23032C117.247 5.12019 117.29 5.01429 117.366 4.93388C117.451 4.86499 117.559 4.83119 117.669 4.83957L117.746 4.84279L120.077 5.02893C120.19 5.03009 120.3 5.06492 120.392 5.12884C120.423 5.15548 120.448 5.18893 120.463 5.22652C120.479 5.26412 120.486 5.30483 120.483 5.34541L120.481 5.38629L120.47 5.52187L120.468 5.5656C120.466 5.61665 120.475 5.66752 120.496 5.71452C120.516 5.76152 120.547 5.80347 120.585 5.8373C120.676 5.9049 120.785 5.94278 120.898 5.94555L120.919 5.94637C121.04 5.93356 121.156 5.89298 121.258 5.82789C122.646 5.23631 124.142 4.93179 125.654 4.93317C125.968 4.93317 126.284 4.94588 126.602 4.9713C126.714 4.97181 126.821 5.01393 126.903 5.08919C126.973 5.17304 127.007 5.28034 126.999 5.38862L126.996 5.46453L126.704 9.01386C126.703 9.12416 126.662 9.23055 126.589 9.31346C126.55 9.3469 126.505 9.3724 126.457 9.38845C126.408 9.40449 126.357 9.41077 126.306 9.40689L126.238 9.40397ZM75.7748 20.9618C75.7379 20.92 75.7098 20.8713 75.6923 20.8185C75.6748 20.7658 75.6682 20.7102 75.6729 20.6549L75.6737 20.6182L76.0866 10.8808C76.0889 10.8284 76.09 10.7765 76.09 10.7252C76.1048 10.1518 75.9328 9.58876 75.5993 9.11879C75.3935 8.86327 75.1296 8.65894 74.8291 8.52249C74.5285 8.38605 74.1997 8.32121 73.869 8.3332C73.8148 8.33098 73.7614 8.32987 73.7087 8.32987C73.3986 8.31351 73.0884 8.36014 72.7973 8.46688C72.5062 8.57362 72.2405 8.73819 72.0165 8.95039C71.5744 9.39729 71.323 9.99434 71.3138 10.6186L70.8982 20.4212C70.9029 20.5378 70.8626 20.6517 70.7854 20.74C70.7431 20.7765 70.6938 20.8041 70.6404 20.8214C70.5871 20.8387 70.5308 20.8452 70.4748 20.8406L70.4364 20.8398L66.8498 20.6919C66.7316 20.6966 66.6161 20.6568 66.5265 20.5806C66.4896 20.5389 66.4615 20.4903 66.444 20.4377C66.4265 20.3851 66.4199 20.3296 66.4246 20.2744L66.4254 20.2371L67.0681 5.07886C67.0658 5.02535 67.0743 4.97193 67.093 4.92168C67.1118 4.87143 67.1405 4.82534 67.1774 4.78609C67.2648 4.71657 67.3759 4.68291 67.4877 4.69208L67.528 4.6929L69.766 4.78521C69.8754 4.78126 69.9829 4.81386 70.0711 4.8777C70.1031 4.90814 70.128 4.94526 70.1437 4.98636C70.1594 5.02745 70.1656 5.07148 70.1618 5.11524L70.1612 5.14122L70.1605 5.17748C70.1532 5.2963 70.1919 5.41342 70.2688 5.50523C70.3104 5.54636 70.36 5.5788 70.4146 5.60062C70.4692 5.62244 70.5278 5.63319 70.5867 5.63223L70.6048 5.63258C70.8016 5.61305 70.9879 5.53612 71.1401 5.41163C72.1547 4.7536 73.3474 4.41367 74.5615 4.4365C74.6699 4.4365 74.7795 4.4388 74.8903 4.44339C76.799 4.5224 78.2154 5.0607 79.1573 6.04861C80.0991 7.03652 80.5758 8.48525 80.5761 10.4095C80.5761 10.5807 80.5723 10.7559 80.5647 10.935L80.1465 20.803C80.1513 20.9195 80.1109 21.0335 80.0336 21.1218C79.9912 21.1582 79.9418 21.1859 79.8884 21.2032C79.835 21.2204 79.7786 21.227 79.7226 21.2223L79.6847 21.2216L76.0981 21.0735C75.9799 21.0781 75.8643 21.0381 75.7748 20.9618ZM26.5833 23.5238C26.5477 23.4832 26.5207 23.436 26.5039 23.385C26.4871 23.3339 26.4809 23.2801 26.4855 23.2267L26.4859 23.2019L26.9127 8.71788C26.9068 8.61475 26.9415 8.51334 27.0095 8.4348C27.0475 8.40245 27.0917 8.37793 27.1395 8.3627C27.1873 8.34747 27.2377 8.34183 27.2878 8.34611L27.3117 8.34646L30.7706 8.44572C30.8836 8.43956 30.9946 8.47664 31.0805 8.54925C31.1161 8.58973 31.143 8.63684 31.1598 8.68779C31.1766 8.73874 31.1828 8.7925 31.1782 8.84587L31.1778 8.87139L30.752 23.3242C30.7583 23.4356 30.7206 23.5451 30.6469 23.6298C30.6058 23.6649 30.558 23.6915 30.5062 23.7081C30.4545 23.7246 30.3999 23.7308 30.3457 23.7262L30.3203 23.7258L26.8931 23.6276C26.7801 23.6336 26.6691 23.5964 26.5833 23.5238ZM24.5174 9.80844C24.5265 9.86071 24.5228 9.91438 24.5065 9.96494C24.4902 10.0155 24.4619 10.0615 24.4239 10.099C24.3858 10.1365 24.3392 10.1644 24.288 10.1805C24.2367 10.1965 24.1823 10.2002 24.1293 10.1912H22.839C22.4412 10.1618 22.0413 10.2104 21.6626 10.3343C21.284 10.4583 20.934 10.655 20.6329 10.9132C20.369 11.2046 20.1674 11.5454 20.0401 11.9154C19.9129 12.2854 19.8625 12.6768 19.8922 13.0664V21.5372C19.9019 21.5937 19.8978 21.6517 19.8801 21.7063C19.8625 21.7609 19.8319 21.8106 19.7908 21.8511C19.7497 21.8917 19.6993 21.9219 19.6439 21.9393C19.5885 21.9567 19.5297 21.9607 19.4724 21.9511H16.0436C15.9864 21.9608 15.9276 21.9567 15.8722 21.9393C15.8168 21.9219 15.7665 21.8917 15.7254 21.8511C15.6843 21.8106 15.6537 21.7609 15.636 21.7063C15.6184 21.6517 15.6143 21.5937 15.6241 21.5372V7.04732C15.6192 6.995 15.6255 6.94224 15.6427 6.89248C15.6598 6.84272 15.6873 6.79706 15.7235 6.75847C15.8142 6.68814 15.9287 6.65458 16.0436 6.66463H18.1831C18.2892 6.65601 18.3952 6.68229 18.4845 6.73937C18.5152 6.76575 18.539 6.79895 18.5541 6.83623C18.5692 6.8735 18.575 6.91378 18.5711 6.95372V7.07833C18.5683 7.12964 18.5773 7.18093 18.5975 7.22829C18.6178 7.27566 18.6486 7.31786 18.6878 7.35171C18.7785 7.41615 18.889 7.44755 19.0005 7.44053C19.1183 7.42537 19.2298 7.37895 19.323 7.30623C20.8026 6.53101 22.4538 6.1292 24.1292 6.13666C24.1822 6.1319 24.2357 6.13816 24.2861 6.15505C24.3364 6.17194 24.3827 6.19908 24.4218 6.2347C24.4932 6.32415 24.5274 6.4371 24.5173 6.55054L24.5174 9.80844ZM31.0321 1.84793C31.4789 2.30478 31.7233 2.91794 31.7116 3.55253L31.7103 3.64011C31.7082 3.95787 31.6422 4.27205 31.5163 4.56454C31.3904 4.85703 31.207 5.12203 30.9767 5.34424C30.7464 5.56646 30.4737 5.74148 30.1745 5.85922C29.8752 5.97696 29.5552 6.03507 29.2331 6.03022C29.203 6.03022 29.1726 6.02977 29.142 6.02887C28.8096 6.02753 28.4808 5.95977 28.1756 5.82969C27.8705 5.69961 27.5952 5.5099 27.3664 5.27202C27.1447 5.04956 26.9703 4.78553 26.8536 4.4956C26.7369 4.20566 26.6802 3.89563 26.6869 3.58377L26.6883 3.49618C26.6988 2.84782 26.9685 2.22977 27.4386 1.77649C27.9088 1.32322 28.5415 1.07141 29.199 1.07583L29.2878 1.07712C29.6165 1.08108 29.941 1.15154 30.241 1.28412C30.541 1.41671 30.8103 1.6086 31.0321 1.84793ZM37.2113 28.9988C37.2609 29.0029 37.3109 28.9967 37.3578 28.9805C37.4048 28.9643 37.4479 28.9386 37.4841 28.9049C37.554 28.8187 37.59 28.7104 37.5854 28.6001L37.8518 22.0585C37.8491 21.9218 37.8883 21.7875 37.9643 21.6731C38.0014 21.6255 38.0495 21.5875 38.1047 21.5621C38.1598 21.5367 38.2203 21.5249 38.2811 21.5274L38.3042 21.5279C38.3337 21.5309 38.3625 21.5392 38.3891 21.5524C38.4182 21.5652 38.4531 21.5827 38.4956 21.6056C39.1648 21.9631 39.91 22.1599 40.6707 22.18C40.8231 22.186 40.973 22.1891 41.1207 22.1891C42.7418 22.2694 44.336 21.7578 45.5988 20.7521C46.2185 20.196 46.7112 19.5165 47.0443 18.7584C47.3774 18.0003 47.5433 17.181 47.5309 16.3548L47.7053 12.0773C47.7098 11.9658 47.712 11.8557 47.712 11.7469C47.7396 11.0028 47.6152 10.2608 47.3463 9.56507C47.0774 8.86931 46.6694 8.23395 46.1466 7.69674C44.886 6.51024 43.2028 5.86046 41.4604 5.8878C41.3775 5.88446 41.2951 5.8828 41.2131 5.88284C40.0501 5.87657 38.9156 6.2373 37.9754 6.91232C37.8667 6.99365 37.7342 7.03806 37.5977 7.03892L37.5721 7.03845C37.5152 7.03946 37.4587 7.02915 37.406 7.00814C37.3533 6.98713 37.3054 6.95585 37.2653 6.91618C37.1912 6.82777 37.1539 6.71494 37.1608 6.60046L37.1615 6.56607L37.162 6.54306C37.1656 6.5016 37.1598 6.45987 37.145 6.42091C37.1302 6.38195 37.1067 6.34674 37.0763 6.31785C36.9926 6.25719 36.8906 6.22632 36.7868 6.23026L34.649 6.1456L34.6144 6.1449C34.5613 6.14046 34.5078 6.1466 34.4572 6.16294C34.4065 6.17928 34.3597 6.20549 34.3195 6.24002C34.2462 6.32381 34.2081 6.432 34.2129 6.54254L33.3208 28.4313L33.3202 28.4632C33.3157 28.5161 33.3225 28.5693 33.3402 28.6194C33.3578 28.6695 33.3859 28.7154 33.4226 28.7542C33.5163 28.8289 33.6344 28.8673 33.7548 28.8624L37.1808 28.9981L37.2113 28.9988ZM38.116 15.5783L38.2474 12.3541C38.247 11.6206 38.5054 10.9097 38.9782 10.3435C39.2123 10.0939 39.4998 9.89893 39.8198 9.77267C40.1399 9.64641 40.4844 9.59209 40.8285 9.61365C40.8829 9.61365 40.9382 9.61476 40.9942 9.61698C41.3562 9.60372 41.7161 9.67541 42.0445 9.82615C42.3728 9.97688 42.6602 10.2024 42.8829 10.484C43.2551 11.0293 43.4428 11.6767 43.4189 12.3336C43.4189 12.3975 43.4176 12.4624 43.4149 12.5282L43.2832 15.7518C43.2905 16.4869 43.0313 17.2004 42.5524 17.7638C42.3147 18.0045 42.0269 18.1916 41.7089 18.3123C41.3909 18.4329 41.0502 18.4842 40.7102 18.4626C40.6539 18.4626 40.5968 18.4615 40.5388 18.4592C40.1784 18.4729 39.8197 18.403 39.4917 18.2551C39.1636 18.1072 38.8754 17.8854 38.6502 17.6075C38.2751 17.0686 38.0863 16.4247 38.1118 15.7715C38.1119 15.708 38.1133 15.6436 38.116 15.5783ZM13.1112 24.9004C12.7876 24.9203 12.4718 24.9302 12.1639 24.9302C10.1805 25.0144 8.22459 24.4482 6.60195 23.3201C4.97124 22.1056 4.06604 20.1512 3.89328 17.4294L3.4712 10.7443C3.47098 10.528 3.38664 10.3201 3.23556 10.1635C3.07015 10.0228 2.85557 9.95143 2.63758 9.96458C2.60513 9.96458 2.57188 9.96563 2.53781 9.96773L0.832683 10.0728L0.756958 10.0752C0.614385 10.0862 0.473045 10.0422 0.362646 9.95255C0.265072 9.84914 0.211878 9.7125 0.214217 9.57126L0.00362115 6.24766L0.00154894 6.18151C-0.0037167 6.11564 0.00447485 6.0494 0.0256383 5.98672C0.0468018 5.92403 0.0805068 5.86617 0.124757 5.81657C0.232911 5.72363 0.372084 5.67341 0.515516 5.67555L2.29933 5.56601C2.51836 5.56592 2.72897 5.48285 2.88766 5.33397C3.03007 5.17101 3.1023 4.95965 3.08896 4.74492C3.08896 4.71263 3.0879 4.67964 3.08577 4.64566L2.83154 0.617931L2.83041 0.582897C2.82717 0.545252 2.83218 0.507361 2.8451 0.471795C2.85803 0.43623 2.87856 0.403824 2.90531 0.376778C2.97811 0.320789 3.06817 0.291093 3.16048 0.292637L7.87802 0.0026694L7.92627 0.00115127C8.0104 -0.00578987 8.09409 0.0188373 8.16061 0.0701106C8.18837 0.0987496 8.21014 0.132504 8.22466 0.169444C8.23919 0.206384 8.24619 0.245786 8.24527 0.285397L8.49986 4.31324C8.49968 4.53799 8.58407 4.75482 8.73668 4.92173C8.81792 4.9945 8.9131 5.0505 9.01663 5.08642C9.12015 5.12234 9.22992 5.13746 9.33946 5.13089C9.37072 5.13089 9.40269 5.12987 9.43537 5.12785L12.0517 4.9671L12.1183 4.965C12.1852 4.95982 12.2524 4.96795 12.316 4.98889C12.3796 5.00983 12.4382 5.04317 12.4885 5.08692C12.5828 5.19354 12.6338 5.33082 12.6316 5.47229L12.8365 8.71724L12.839 8.79601C12.8508 8.9465 12.8027 9.09561 12.705 9.21175C12.5921 9.3149 12.4433 9.37124 12.2895 9.36905L9.67344 9.52969C9.45566 9.52969 9.24568 9.60959 9.08434 9.75385C9.01395 9.83048 8.95979 9.9202 8.92503 10.0178C8.89027 10.1153 8.87561 10.2187 8.88191 10.3219L8.88482 10.4121L9.25781 16.3154C9.25499 17.3455 9.58286 18.35 10.1945 19.185C10.4841 19.5124 10.8459 19.7701 11.252 19.9385C11.6581 20.1069 12.0979 20.1815 12.5378 20.1565C12.6402 20.1565 12.7447 20.1533 12.8516 20.1468L12.9099 20.1449C12.9727 20.1401 13.0358 20.1483 13.0952 20.1691C13.1545 20.1899 13.2088 20.2228 13.2545 20.2656C13.3451 20.3752 13.3937 20.5127 13.3917 20.6542L13.6262 24.3678L13.628 24.4253C13.6329 24.4873 13.6245 24.5496 13.6034 24.6083C13.5823 24.6669 13.5489 24.7205 13.5054 24.7656C13.3941 24.8548 13.2546 24.9025 13.1112 24.9004Z" fill="#078372"/>
              </svg>
            </span>
          </h2>

          <h3>${translations.userMenu.confirmEmail}</h3>
          <p>${translations.userMenu.verificationProcess }</p>

          <p>${ translations.userMenu.noEmail } <a class="resend">${ translations.userMenu.resend }</a>
        `;
        return body;
      }
      
    }
  }
})();
